import {
  DocumentSummaryPromptDocumentType,
  DocumentType,
} from '@/types/schema';

import { DOCUMENT_RELATIONSHIP_LOOKUP } from '../../ManageDocumentAmendments/utils/ManageDocumentAmendments.utils';

/**
 * Returns the document summary prompt document types for a given document type,
 * including associated parent types for amendment/codicil documents. For example,
 * a trust amendment will return both TRUST_AMENDMENT and SIGNED_TRUST_DOCUMENT,
 * so that prompts configured for trusts are also available when summarizing
 * amendments. Primary document types (e.g. trusts, wills) only return themselves.
 */
export function getDocumentSummaryPromptDocumentTypes(
  documentType: DocumentType
): DocumentSummaryPromptDocumentType[] {
  const relationship = DOCUMENT_RELATIONSHIP_LOOKUP[documentType];
  if (relationship && relationship.primary !== documentType) {
    return relationship.compatible.map(
      (t) => t as unknown as DocumentSummaryPromptDocumentType
    );
  }
  return [documentType as unknown as DocumentSummaryPromptDocumentType];
}
